
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/myaccount/order/[id]",
      function () {
        return require("private-next-pages/myaccount/order/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/myaccount/order/[id]"])
      });
    }
  